import React, { useState } from 'react';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'Acceso inmediato por email en menos de 5 minutos. Todo en PDF descargable.'
}, {
  q: '¿Sirve para clubes y entrenadores particulares?',
  a: 'Sí. Club, academia, entrenamiento particular o escuela deportiva.'
}, {
  q: '¿Los 6 bonos están en las dos ofertas?',
  a: 'Sí. Incluidos en ambas opciones sin costo adicional.'
}, {
  q: '¿Sirve si soy entrenador nuevo?',
  a: 'Sí. Abres el tomo, lees 3 minutos y entras a la cancha con todo resuelto.'
}, {
  q: '¿Qué pasa con jugadores de distintos niveles?',
  a: 'Cada sesión incluye variantes para nivel más fácil y más difícil.'
}, {
  q: '¿Qué diferencia tiene con otros materiales?',
  a: 'Es el único sistema que cubre técnica, táctica, físico, planificación, evaluación y gestión en un solo lugar.'
}, {
  q: '¿Por qué elegir el Combo con Kit Táctico Pro?',
  a: 'Resuelve el día del partido: tiempo muerto, marcador en contra y dirección táctica clara.'
}, {
  q: '¿Tiene garantía real?',
  a: '7 días sin preguntas. 100% de tu dinero de vuelta si no es lo que esperabas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#0A0A0F] py-12 px-4" data-id="element-40">
      <div className="max-w-2xl mx-auto" data-id="element-41">
        <h2 className="text-2xl sm:text-3xl font-black text-white text-center mb-6" data-id="element-42">
          Preguntas <span className="text-[#FF6B00]" data-id="element-43">Frecuentes</span>
        </h2>

        <div className="bg-[#16161F] border border-[#FF6B0033] rounded-2xl divide-y divide-[#FF6B0033] overflow-hidden" data-id="element-44">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} data-id="element-45">
                <button className="w-full text-left px-5 py-3.5 flex items-center justify-between gap-3" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-46">
                  <span className="text-white font-bold text-sm" data-id="element-47">{faq.q}</span>
                  <span className={`text-[#FF6B00] text-lg flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`} data-id="element-48">
                    +
                  </span>
                </button>
                {isOpen && <div className="px-5 pb-4 -mt-1" data-id="element-49">
                    <p className="text-[#B0B0C0] text-xs sm:text-sm leading-relaxed" data-id="element-50">
                      {faq.a}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}